import { render, staticRenderFns } from "./CompetitorPage.vue?vue&type=template&id=08885811&"
import script from "./CompetitorPage.vue?vue&type=script&lang=js&"
export * from "./CompetitorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports